var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7275_59219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53572 6.57245L6.7073 9.40088C6.31677 9.79141 5.68361 9.79141 5.29308 9.40088L2.46465 6.57245C1.48834 5.59614 1.48834 4.01323 2.46465 3.03692C3.44097 2.06061 5.02388 2.06061 6.00019 3.03692C6.9765 2.06061 8.55941 2.06061 9.53572 3.03692C10.512 4.01323 10.512 5.59614 9.53572 6.57245Z",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7275_59219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostHeart);
export default __webpack_public_path__ + "static/media/postHeart.1afbe727b86806fb35145c8aaf4353be.svg";
export { ForwardRef as ReactComponent };